// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"e1d4a881cfb2a409dfc6","339":"e83b1d16dc2d61092e10"}[chunkId] + ".js";
};